import { Backdrop, Fade, Typography } from '@mui/material'
import Breadcrumbs from 'components/common/Breadcrumbs'
import Grid from 'components/common/Grid'
import Stack from 'components/common/Stack'
import React, { useState } from 'react'
import { Formik } from "formik";
import Box from 'components/common/Box'
import * as yup from "yup";
import Text from 'components/common/Text'
import { makeStyles } from '@mui/styles'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TextField from 'components/common/TextField'
import Button from "components/common/Button";
import Card from 'components/common/Card'
import CardContent from 'components/common/CardContent'
import Modal from 'components/common/Modal'

const AddConnector = ({ submitConnector, handleAddConnnector }) => {
  const [open, setOpen] = useState(false);
  const initialValues = {
    ac_connector_name: "",
    dc_connector_name: "",
    acConnectorFile: null,
    dcConnectorFile: null
  };

  const classes = useStyles();

  const handleClose = () => {
    setOpen(false); 
  };

  const validateconnectorForm = yup.object().shape({
    ac_connector_name: yup.string(),
    dc_connector_name: yup.string(),
    acConnectorFile: yup
      .mixed()
      .test(
        "FILE_SIZE",
        "Image size should be less than 1 MB",
        (value) => !value || (value && value.size <= 1024 * 1024)
      ),
    dcConnectorFile: yup
      .mixed()
      .test(
        "FILE_SIZE",
        "Image size should be less than 1 MB",
        (value) => !value || (value && value.size <= 1024 * 1024)
      ),
  });

  return (
    <>
      <Grid container>
        <Stack mt={2}>
          <Breadcrumbs
            sx={{ fontSize: "14px", color: "#0DA861" }}
            separator="›"
            aria-label="breadcrumb"
          >
           <Typography sx={{  color: '#A2A7AE', fontSize:'14px', cursor:'pointer'}}  onClick={() => handleAddConnnector('')}     >

              Connector
           </Typography>
          
            <Typography sx={{ fontSize: "14px" }} color="#0DA861">
              Add Connector
            </Typography>
          </Breadcrumbs>
        </Stack>
        <Formik
          initialValues={initialValues}
          onSubmit={(values) => {
     
            let ConnectorformData = new FormData();
            ConnectorformData.append("ac_connector_name", values.ac_connector_name);
            ConnectorformData.append("dc_connector_name", values.dc_connector_name);
            ConnectorformData.append("acConnectorFile", values.acConnectorFile);
            ConnectorformData.append("dcConnectorFile", values.dcConnectorFile);
            for (var pair of ConnectorformData.entries()) {
              console.log(pair[0]+ ', ' + pair[1]); 
          }
         
            submitConnector(ConnectorformData);
            values.ac_connector_name = "";
            values.dc_connector_name = "";
            values.acConnectorFile = null;
            values.dcConnectorFile = null;
          }}
          validationSchema={validateconnectorForm}
        >
          {({
            handleChange,
            handleBlur,
            handleSubmit,
            isValid,
            values,
            touched,
            errors,
            setFieldValue,
          }) => (
            <>
              <Box className={classes.center} sx={{ marginTop: "1rem" }}>
                <Card>
                  <CardContent>
                    <Box>
                      <Text
                        className={classes.menutext}
                        variant="h5"
                        color="#202020"
                        sx={{
                          fontSize: "24px",
                          fontWeight: "bold",
                          marginBottom: "40px",
                        }}
                      >
                        <ArrowBackIcon
                          sx={{
                            fontSize: "22px",
                            fontWeight: "bold",
                            cursor: 'pointer'
                          }}
                          onClick={() => handleAddConnnector('')}
                        />
                        Add Connector
                      </Text>

                      <Stack direction={"row"} spacing={37.5}>
                        <Stack xs={6}>
                          <Text sx={{ color: "#666666", fontSize: "14px" }}>
                            AC Connector
                          </Text>
                          <Box className={classes.menuinput} sx={{ width: "20rem" }}>
                            <TextField
                             classes={{ root: classes.customTextField }}
                            placeholder="Enter AC connector name"
                              size="small"
                              sx={{ width: "19rem" }}
                              onInput={(e) => {
                                e.target.value = e.target.value.trimStart();
                              }}
                              onBlur={handleBlur("ac_connector_name")}
                              onChange={handleChange("ac_connector_name")}
                              value={values.ac_connector_name}
                              error={
                                touched.ac_connector_name && Boolean(errors.ac_connector_name)
                              }
                            />
                            {errors.ac_connector_name && (
                              <Typography sx={{ color: "red" }}>
                                {errors.ac_connector_name}
                              </Typography>
                            )}
                          </Box>
                        </Stack>

                        <Stack xs={6}>
                          <Text sx={{ color: "#666666", fontSize: "14px", marginTop: '20px' }}>
                            Add AC Connector Image
                          </Text>
                          <Box
                            className={classes.form_container}
                            sx={{ marginTop: "-10px" }}
                          >
                            <Box
                              sx={{
                                width: "300px",
                                height: "25px",
                                border: "1px solid rgba(0, 0, 0, 0.27)",
                                padding: "10px 10px",
                                borderRadius: "5px",
                              }}
                            >
                              <input
                                id="file"
                                name="photo"
                                type="file"
                                className="form-control"
                                accept="image/*"
                                onChange={(event) => {
                                  setFieldValue("acConnectorFile", event.currentTarget.files[0]);
                                }}
                                error={!touched.acConnectorFile && Boolean(errors.acConnectorFile)}
                              />
                              {errors.acConnectorFile && (
                                <Typography sx={{ color: "red", margin: "15px -10px" }}>
                                  {errors.acConnectorFile}
                                </Typography>
                              )}
                            </Box>
                          </Box>
                        </Stack>
                      </Stack>
                      <Stack direction={"row"} spacing={37.5}>
                        <Stack xs={6}>
                          <Text sx={{ color: "#666666", fontSize: "14px", marginTop: '20px' }}>
                            DC Connector
                          </Text>
                          <Box className={classes.menuinput} sx={{ width: "20rem" }}>
                            <TextField
                            placeholder="Enter DC connector name"
                            classes={{ root: classes.customTextField }}
                              size="small"
                              sx={{ width: "19rem" }}
                              onInput={(e) => {
                                e.target.value = e.target.value.trimStart();
                              }}
                              onBlur={handleBlur("dc_connector_name")}
                              onChange={handleChange("dc_connector_name")}
                              value={values.dc_connector_name}
                              error={
                                touched.dc_connector_name && Boolean(errors.dc_connector_name)
                              }
                            />
                            {errors.dc_connector_name && (
                              <Typography sx={{ color: "red" }}>
                                {errors.dc_connector_name}
                              </Typography>
                            )}
                          </Box>
                        </Stack>

                        <Stack xs={6}>
                          <Text sx={{ color: "#666666", fontSize: "14px", marginTop: '40px' }}>
                            Add DC Connector Image
                          </Text>
                          <Box
                            className={classes.form_container}
                            sx={{ marginTop: "-10px" }}
                          >
                            <Box
                              sx={{
                                width: "300px",
                                height: "25px",
                                border: "1px solid rgba(0, 0, 0, 0.27)",
                                padding: "10px 10px",
                                borderRadius: "5px",
                              }}
                            >
                              <input
                                id="file"
                                name="photo"
                                type="file"
                                className="form-control"
                                accept="image/*"
                                onChange={(event) => {
                                  setFieldValue("dcConnectorFile", event.currentTarget.files[0]);
                                }}
                                error={!touched.dcConnectorFile && Boolean(errors.dcConnectorFile)}
                              />
                              {errors.dcConnectorFile && (
                                <Typography sx={{ color: "red", margin: "15px -10px" }}>
                                  {errors.dcConnectorFile}
                                </Typography>
                              )}
                            </Box>
                          </Box>
                        </Stack>
                      </Stack>
                      <Stack mt={1.5} direction={"column"}>
                        <Button
                          sx={{
                            width: "200px",
                            borderRadius: '10px',
                            height: "51.41px",
                            fontSize: "16px",
                            marginTop: '100px',
                            background: '#19AA69',
                            color: 'white',
                          }}
                          size="small"
                          disabled={
                           
                             !values.ac_connector_name && !values.dc_connector_name
                               
                          }
                          onClick={handleSubmit}
                        >
                           Add Connector
                        </Button>
                      </Stack>
                    </Box>

                    <Modal
                      aria-labelledby="transition-modal-title"
                      aria-describedby="transition-modal-description"
                      open={open}
                      onClose={handleClose}
                      closeAfterTransition
                      size="xss"
                      BackdropComponent={Backdrop}
                    >
                      <Fade in={open}>
                        <div className={classes.modal}>
                          <img
                            src="../images/successful.svg"
                            alt="logo"
                            style={{ marginTop: "10px" }}
                          ></img>
                          <h4 id="transition-modal-title">Connector Added Successfully</h4>
                      
                            <Button variant="contained" color="primary" onClick={() => handleAddConnnector('')}style={{ padding: '5px 50px', fontSize: "14px" }}>ok</Button>
                          
                        </div>
                      </Fade>
                    </Modal>
                  </CardContent>
                </Card>
              </Box>
            </>
          )}
        </Formik>
      </Grid>
    </>
  )
}

const useStyles = makeStyles((theme) => ({
  customTextField: {
    "& input::placeholder": {
      fontSize: "14px"
    }
  },
  center: {
    width: "100%"
  },

  form_container: {
    padding: "10px 0 0 0",
    width: "80%",
  },
  modal: {
    textAlign: 'center'
  }
}));

export default AddConnector;
